import { createFileRoute } from '@tanstack/react-router';

import { getMobilityOptions } from '@/module/Author/Mobility/model/MobilityQuery';

export const Route = createFileRoute('/_auth/author/_author/mobility/_mobility/$mobilityId/_layout')({
  loader: async ({ params: { mobilityId }, context: { queryClient } }) => {
    const mobility = await queryClient.ensureQueryData(getMobilityOptions(mobilityId));

    return {
      mobility,
      crumb: String(mobility.year),
    };
  },
});
